
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import { getExchangeAccount, exchangeBean } from '../common/js/api.js'
import { getCookie, setCookie, removeCookie } from '../common/js/utils'
import router from '@/router/index.js'

export default {
directives: {
TransferDom
},
components: {
Box,
XButton,
XInput,
Group,
TransferDom
},
methods: {
onSubmit(val) {
let self = this
if (!this.entity.amount) {
self.$vux.toast.text('请输入鸥豆数量')
return
}
if (this.entity.amount <= 0) {
self.$vux.toast.text('鸥豆数量需要大于0')
return
}
if (this.entity.amount > self.beans) {
self.$vux.toast.text('鸥豆数量不能大于可用数量')
return
}
this.$vux.confirm.show({

title: '提醒您',
content: '确定要付豆吗？',
onCancel() {},
onConfirm() {
self.$vux.loading.show({
text: '正在付豆...'
})
exchangeBean({
data: {
userId: self.userId,
amount: self.entity.amount
}
}).then(function(data) {
self.$vux.loading.hide()

router.replace({ path: '/success', query: { message: '付豆成功' } })
})
}
})
}
},
data() {
return {
lessTime: 0,
view: {
codeText: '获取验证码',
disabled: false,
sendCode: false
},
entity: {
mobile: '',
code: ''
},
userId: '',
beans: 0,
total: 0
}
},
created() {
let self = this
this.userId = this.$route.query.userId
getExchangeAccount({}).then(function(data) {
self.beans = data.Content
self.total = data.Message
})
}
}



// WEBPACK FOOTER //
// ./src/components/exchangeBean.vue